import { render } from "./OrderCopyPaste.vue?vue&type=template&id=fcd3bdd2"
import script from "./OrderCopyPaste.vue?vue&type=script&lang=js"
export * from "./OrderCopyPaste.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__